import { APP_ROUTES } from '../constants';

export const isEmployerRole = (role) => role === 'employer' || role === 'hr_manager';

export const isEmployerContactVerified = (user) => (
  !isEmployerRole(user?.role) ||
  Boolean(user?.emailVerifiedAt && user?.phoneVerifiedAt)
);

export const getEmployerOnboardingPath = (user, verificationStatus) => {
  if (isEmployerRole(user?.role) && !isEmployerContactVerified(user)) {
    return APP_ROUTES.CONTACT_VERIFICATION;
  }

  return verificationStatus === 'verified'
    ? APP_ROUTES.HOME
    : APP_ROUTES.KYC_VERIFICATION;
};
